// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1M0w_","label":"Section_label__1reor","contentWrap":"Section_contentWrap__3I34z","footer":"Section_footer__1XzuC","footerInner":"Section_footerInner__7rj0P"};